import * as React from "react";
const SvgHelmetFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.5 5a7.5 7.5 0 0 1 7.5 7.5l-.002-.146 3.415 1.549c.944.427.685 1.803-.296 1.904l-.117.006H3a1 1 0 0 1-.875-1.483l.88-1.595L3 12.5a7.5 7.5 0 0 1 7.258-7.496z" }));
export default SvgHelmetFill;
